import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "After 9 months of freedom, today I start a new job",
  "description": "",
  "published": "2019-07-22T00:00:00.000Z",
  "redirect_from": ["/blog/after-9-months-of-freedom-today-i-start-a-new-job/swizec/9161"],
  "categories": "Personal",
  "hero": "./img/QT98xC0.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Well, my old job ... that I never quite left. It's complicated.`}</p>
    <p>{`Let me tell you a story, friend. A story of freedom, hustle, side gigs, boundless ambition, and a very expensive city.`}</p>
    <p>{`October 2018 I quit my job to focus on the sidehustle – teaching React. It was scary. Terrifying.`}</p>
    <p>{`But leaving the only full-time job I'd ever had felt good. Refreshing. I didn't like my boss and the work got boring.`}</p>
    <p>{`Well, I actually quit in March. It took until October to set up a company and `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/sponsored-genius-visa/swizec/8612"
      }}>{`sponsor my own O-1 visa`}</a>{`. Ain't it fun being an immigrant. 😅`}</p>
    <p>{`Many thanks to everyone involved for letting me get away with these shenanigans. Quitting and being allowed to stay for 7 months while you deal with immigration is no joke.`}</p>
    <p><img parentName="p" {...{
        "src": "/3b54eae03ec10519e9611de6595e7cd3/media-IcGkqdUmYLFGE-giphy.gif",
        "alt": "thank_you giphy"
      }}></img></p>
    <p>{`Now here's the problem: When I finally got my freedom in October, my business was all but dead.`}</p>
    <p>{`The stress of dealing with immigration, training a React team at a large Fortune5 company, a full-time day job with boss problems, and trying to keep infoproducts selling almost killed my business. You can read about that in my annual review 👉 `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/sidehustled-180k-almost-killed-my-business/swizec/8835"
      }}>{`How I sidehustled `}{`\\`}{`\\`}{`\\`}{`$180k and why it almost killed my business`}</a></p>
    <h2 {...{
      "id": "freedom"
    }}>{`Freedom`}</h2>
    <p>{`So here I was. Free of all shackles, immigration or otherwise, a few thousand dollars in the hole, contracting 4 days/week at my old job, and product sales that looked like this.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/238e72c0a24efeb8b2be79c5c253dafd/1d7f7/QT98xC0.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.71300448430493%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'270\\'%20viewBox=\\'0%200%20400%20270\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M46%2047c-5%202-6%209-2%2013%203%202%203%202%2027%202h23l3-2c3-4%203-10-2-13-3-1-45-2-49%200m246%2096a17520%2017520%200%2000-3%2098c-1%200-2%203-2%207s-1%206-2%206c-2%200-3-2-4-16%200-12-2-11-2%201%200%2014-2%2018-4%2012l-2-3-1%203c-1%207-4%203-4-7s-2-10-2%200l-2%2010c-1%200-3-4-3-7%200-5-2-3-2%202-2%209-3%206-5-8%200-8-2-6-2%203l-1%206-1-1c0-2-2-1-2%202%200%204-2-5-2-11%200-7-2-6-2%201%200%2011-1%2013-5%2013s-4-1-4-5l-1-12-1-6-1%205-2%2018-1-3-1-10c-1-8-3-6-3%203l-1%207c-1%201-1%201-1-1%200-3-2-3-2%201%200%202-1%203-3%203s-3-1-4-10c0-8-2-11-2-5l-1%207c-1%202-1%202-1%200%200-6-2-5-3%202l-1%207-1-4-2-2h-2c-1-1-1-1-2%201%200%203-3%204-3%201l-2%201-2%202v-3l-1-11c0-15-2-14-2%200-1%2014-2%2017-4%2011%200-3-2-3-2%200%200%202%200%203-3%203-3-1-4-3-4-12%200-8-2-10-2-2%200%206-2%2015-2%2011l-1-3-2%203-1%203v-3c0-4-2-4-2%200-1%204-4%204-5%200%200-4-2-4-2%200-1%204-3%203-3-2%200-4-2-10-2-7l-2%206-2%205c0%203-2%200-2-3%200-8-2-10-2-3-1%207-3%208-3%204l-2-3-2-10-1-10v7l-2%2012c0%207-1%208-5%206h-3c-2%202-4%201-4-2-1-4-3-4-3%200l-1-4-2-5c-1%201-2-3-2-10v-4l-1%205-1%2013-1%207c-2%201-4-2-5-7l-1-5-1%204-1%205v-5c-1-5-3-3-3%203%200%205-1%206-4%206s-4%200-4-3c-1-4-4-5-5-2l-1-1c-1-1-1-1-1%202%200%204%202%206%202%202%201-4%203-4%204%200%200%203%200%203%205%203%204%200%205-1%205-4l1-4v4c1%205%203%205%203%201v-2l1%202c0%202%201%203%204%203h3v-11l1%206c1%205%201%205%202%203s1-2%201%200%203%203%203%200h1c0%202%201%202%207%202h7l1-7%201-6v6c0%206%200%207%202%206h1c0%202%204%201%204-2l1-2v2c0%204%204%204%205%200%201-5%203-6%203-2s2%206%205%204h1c0%202%205%201%205-1h1c0%202%203%203%203%201h1c2%202%203%201%203-2v-3l1%203c1%203%201%203%205%203%203%200%204%200%204-2h1l2%202c2%200%202-1%202-5l1-5v5c0%205%202%207%205%204h1c0%202%204%201%204-1h1c1%202%201%202%202%200h1l1%202c2%200%203-3%203-7%200-2%200-2%201-1l1%204%201%204%201-5c0-6%201-6%202%200%200%204%201%205%203%205l4-1h2c1%203%203-1%203-7v-6l1%207c1%206%202%207%203%207s2-1%202-3l1-3v3c1%203%201%203%206%203s5%200%206-3c1-4%201-5%201-1%200%205%202%205%203%201l1-2v2c2%204%203%203%203-3s1-6%201%201c1%204%202%205%203%205l2-2h1c3%204%206%202%206-2l1-4v4c0%204%200%204%203%204%202%200%203%200%203-2h1l4%202c2%200%202%200%202-7%200-6%200-6%202%203%200%204%200%204%203%204s3%200%203-5l1-4c2%201%202-7%203-31l1-24v21l2%2023c1%203%202-1%202-9%200-9%200-9%201%203%200%209%201%2012%202%2013l1-5c0-3%200-4%201-2%201%208%202%209%204%204%201-3%201-3%202%203%202%208%203%208%203-1s2-10%202-1l2%209%202%204%202%202%201-19v-18l1%2013c1%2014%203%2021%203%2012v-5l1%206c3%2022%205%2010%205-28l1-25%201%206v-5c1-3%201-2%201%204a415%20415%200%20006%2057l1-3v2c0%202%201%203%202%203%202%200%203-3%203-14%200-7%200-10%201-8l1%203v-3l1%209%201%2012c1%201%202-4%202-10a3829%203829%200%20003%205l2%202c1%202%201%202%201%200l-2-4c-1-1-2-3-2-9%200-9-2-13-2-5%200%2012-2%2015-2%203l-1-17v-4l-1%205-1%205v-5l-1-5-1%2011c0%2015-1%2028-2%2027l-1-4c0-6-2-10-2-5a933%20933%200%2001-7-75c0%204-1%201-1-6-1-23-2-5-2%2029%200%2036-1%2061-2%2054l-1-13c0-13-2-16-2-4v9l-1-10-1-35c0-45-2-39-2%2012a580%20580%200%2001-4%2042l-2-10c-1-12-4-12-4%200v6l-1-5c-1-5-4-6-4-1%200%206-2-6-2-15%200-14-2-17-2-4%200%2021-2%2013-2-10a1163%201163%200%2001-3%2010l-1%2014v-15a2608%202608%200%2001-3-74M78%20235c0%205%200%206-1%203-1-5-2-2-3%205%200%204-1%206-2%205l-1%203c-1%204-4%204-4-1l-1-6-1-3v2c-1%204-5%207-6%206%200-1-1-1-1%201h-1c0-3-2-2-2%200l-1%203-1-2-1-3-1%202-1%203-1-2c0-4-2-5-3-1-2%204-3%204-4%201%200-4-2-4-2%200-1%203-4%204-4%201l-1-4c-2-1-2-1-3%201l-1%201c0-3-2-1-2%202l-1-5c-1-7-3-6-3%201l-1%204c0%202-3%202-3%200s-2-5-3-4l-2-6v-7l-1%204-1%2016%201-4v-4l1%204c1%204%201%204%202%200%201-2%201-2%202%201%200%204%205%204%206%200l1-2v2c0%203%203%204%203%201h1c0%203%202%201%202-2%200-2%200-2%201%201s4%204%207%202h1c0%203%204%201%205-2s1-3%201-1c0%203%202%205%203%203h6c1%201%201%201%201-1h1c0%203%202%202%202-1l3-4c2-1%202-1%202%203s0%204%202%204l4-2c1-1%201-1%201%201%200%203%202-3%202-8%200-7%202-3%202%205v5l1-6c1-6%202-8%202-2%200%207%202%208%203%202v-4l1%204c1%202%201%203%201%201l1-3v-6l-1%201c-1%201-1-2-1-7%200-12-2-10-2%202%200%2011-2%208-2-3l-1-7-1%207m302-6l-1%209c0%209-2%2018-2%2012%200-2-2-3-2-1h-1c-1-1-1-1-2%202%200%204-6%205-7%200l-1-3-2-7c0-7-1-6-2%203l-2%208v2c1%201%201%200%202-2%201-6%202-7%202-1%200%203%200%204%201%203h1c2%202%209%201%209-1h1c0%202%201%202%201%201h2c1%202%203%200%203-4v-4l1%205%201%205v-6c0-9-1-22-2-21\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/238e72c0a24efeb8b2be79c5c253dafd/ca0a1/QT98xC0.webp 223w", "/static/238e72c0a24efeb8b2be79c5c253dafd/75680/QT98xC0.webp 445w", "/static/238e72c0a24efeb8b2be79c5c253dafd/8d1ba/QT98xC0.webp 890w", "/static/238e72c0a24efeb8b2be79c5c253dafd/3838e/QT98xC0.webp 1335w", "/static/238e72c0a24efeb8b2be79c5c253dafd/e11e5/QT98xC0.webp 1780w", "/static/238e72c0a24efeb8b2be79c5c253dafd/4c9c7/QT98xC0.webp 2038w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/238e72c0a24efeb8b2be79c5c253dafd/e92b6/QT98xC0.png 223w", "/static/238e72c0a24efeb8b2be79c5c253dafd/e66bf/QT98xC0.png 445w", "/static/238e72c0a24efeb8b2be79c5c253dafd/4ef49/QT98xC0.png 890w", "/static/238e72c0a24efeb8b2be79c5c253dafd/4e814/QT98xC0.png 1335w", "/static/238e72c0a24efeb8b2be79c5c253dafd/701e9/QT98xC0.png 1780w", "/static/238e72c0a24efeb8b2be79c5c253dafd/1d7f7/QT98xC0.png 2038w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/238e72c0a24efeb8b2be79c5c253dafd/4ef49/QT98xC0.png",
              "alt": "QT98xC0",
              "title": "QT98xC0",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Damn right I continued contracting at my old job! Have you seen how expensive San Francisco gets?`}</p>
    <p>{`We struck a deal.`}</p>
    <p>{`Swizec shapes up, stops coming to work tired and groggy, contributes like there's no tomorrow, and we promise to let him come in, get his work done, and go home. No startup kool-aid, just a proper business relationship between adults.`}</p>
    <p>{`I rolled up my sleeves and got to work.`}</p>
    <p>{`Found some other freelance clients, dusted off my infoproducts, ran a couple of launches, and embarked on a huge revamp of React for Dataviz. Things were looking great.`}</p>
    <p>{`Product sales were ... heh.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/31b266fa40166c18404186e7d9520668/d3b46/s067u18.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.0896860986547%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M291%2016l-1%209%201%208h25V16l-12-1-13%201m-95%2036l-3%2037c-2%2029-6%2063-7%2062l-2-14-3-14-4%2028-2%2011-4-27h-3c-4%200-3-2-6%2032l-3%2029v2h-55l-54%201h55l55-1%203-28c3-33%203-33%205-33l2%201%205%2030c1%200%202-4%204-22s2-18%205%200l2%2013%201-1%202-17a576%20576%200%20008-64l4%20121%203-3v-2l-2%203v-4a6828%206828%200%2000-5-136l-1-9v5m56%20147\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/31b266fa40166c18404186e7d9520668/ca0a1/s067u18.webp 223w", "/static/31b266fa40166c18404186e7d9520668/75680/s067u18.webp 445w", "/static/31b266fa40166c18404186e7d9520668/8d1ba/s067u18.webp 890w", "/static/31b266fa40166c18404186e7d9520668/3838e/s067u18.webp 1335w", "/static/31b266fa40166c18404186e7d9520668/3802d/s067u18.webp 1690w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/31b266fa40166c18404186e7d9520668/e92b6/s067u18.png 223w", "/static/31b266fa40166c18404186e7d9520668/e66bf/s067u18.png 445w", "/static/31b266fa40166c18404186e7d9520668/4ef49/s067u18.png 890w", "/static/31b266fa40166c18404186e7d9520668/4e814/s067u18.png 1335w", "/static/31b266fa40166c18404186e7d9520668/d3b46/s067u18.png 1690w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/31b266fa40166c18404186e7d9520668/4ef49/s067u18.png",
              "alt": "s067u18",
              "title": "s067u18",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7445f3519b21f17ffd6467340900b2da/1a867/GjiLSO4.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.16143497757847%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'273\\'%20viewBox=\\'0%200%20400%20273\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M44%2045c-5%202-6%208-3%2012l2%203h51l2-3c3-3%203-6%200-10l-3-2-23-1-26%201m-26%2092a45506%2045506%200%20011%2032l2%2020%201%2010v-11c2-31%203-31%203%203%202%2072%203%2081%205%2032%200-28%201-28%203%200l1%2015h9l1%208c1%208%202%209%204%209s4-10%206-31l1-13%201%2019%202%2023%201%205v-4l2-8%201-3v4c2%2011%201%2010%2010%2010h9v-6c2-9%203-9%203-1%201%208%202%209%203%202%202-9%202-10%203-2%201%205%202%207%204%207s2%201%204-42l1-17v20c1%2028%202%2039%203%2038l3-17%203-16%201%204a654%20654%200%20015%2030l2-6%201-7%201%207c1%205%201%206%203%206%203%200%203%200%204-10%201-19%202-20%202-5%201%2016%202%2018%204%208l1-7%201%205c2%2010%201%209%207%209h6l1-11c1-8%202-10%203-9%202%202%202%200%203-14%200-16%201-16%202%200l5%2034%202-5c1-10%202-10%202-2%201%209%203%209%204-1l1-7%201%204c1%207%202%209%203%209a915%20915%200%20006-60c2%2035%202%2043%204%2043%201%200%202%201%203%2011l2%208%202-9c1-8%202-10%203-10%201-1%202-2%202-7l2-6%203%2016%202%2016h6c5%200%205-1%206-4%202-11%201-11%203-3%201%208%202%208%203-1l2-6%201%207%201%207h14l1-9c2-12%203-12%205-1l2%209%205%201c8%200%208%200%209-16%202-17%202-19%203-10%201%207%203%208%206%206%202-2%202-2%203%205%201%208%204%2015%205%2015l2-16a287%20287%200%2001-1-4l-2%2015-3-10c-2-11-2-11-4-8-3%204-4%203-5-8-1-9-3-15-3-10l-4%2039h-8c-2%200-2-1-4-11-1-7-1-8-3-8s-3%202-4%2010c-1%2010-3%2012-6%209h-3c-3%202-4%201-5-8-2-12-2-13-4-3l-1%208-2-8-1-8c-1%200-2%204-2%209-2%208-3%2010-4%2010l-4%201c-1%200-2%200-2-2a1032%201032%200%2001-7-37l-2%2010c-1%207-2%209-3%209s-2%201-2%206c-2%209-3%2010-3%202-1-6-2-7-3-8-2%200-2-3-3-33l-2-40-1-7v10l-2%2027c-3%2049-4%2059-5%2048-1-7-2-6-3%203l-2%208-1-8c-2-9-3-9-3%200-2%2012-4%202-6-31l-2-17-2%2017c-1%2020-2%2022-3%2022-1-1-2%201-3%207-2%2015-2%2014-6%2014h-4l-1-7c-2-14-2-14-3-11l-2%207-2-8a405%20405%200%2001-2-20l-2%2020c-1%2022-3%2024-5%209-2-10-3-11-4-3%200%208-2%207-2-2l-5-24-4%2021-2%209a1055%201055%200%2001-3-71%20690%20690%200%2000-5%2080c-1%201-1-1-3-10-2-11-3-12-4-2%200%208-1%207-3-2%200-8-2-7-3%204l-1%2010H65l-1-8c-2-12-3-14-4-7a656%20656%200%2000-4-37c-1-10-1-6-3%2016-1%2016-4%2034-5%2034s-2-2-3-10l-1-8H34v-4l-3-52c-1-5-2%208-2%2028%200%2027-2%2020-2-15-1-38-2-62-3-52l-1%2023-2%2018-1-23a347%20347%200%2000-2-22m313%2045a438%20438%200%2000-6%2073c-1%201-2-3-3-11-1-10-2-9-4%203s-3%2011-5-1l-2-10-2%2010-2%2010h-14l-1-11-2-11-2%207-1%208-1-8a1009%201009%200%20012%209c2-10%202-10%202-3%202%2011%201%2010%2011%2010h8l1-6%201-7%201%207c1%205%201%206%203%206s3-1%203-5c2-9%202-10%203-3l3%208c3%201%203-2%204-30%203-47%204-52%205-18%201%2028%202%2044%203%2043l2-5%201-5%201%207%201%208h45l-22-1h-22l-1-9c-1-11-3-13-4-7l-1%205a828%20828%200%2001-3-69l-2%206\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7445f3519b21f17ffd6467340900b2da/ca0a1/GjiLSO4.webp 223w", "/static/7445f3519b21f17ffd6467340900b2da/75680/GjiLSO4.webp 445w", "/static/7445f3519b21f17ffd6467340900b2da/8d1ba/GjiLSO4.webp 890w", "/static/7445f3519b21f17ffd6467340900b2da/3838e/GjiLSO4.webp 1335w", "/static/7445f3519b21f17ffd6467340900b2da/e11e5/GjiLSO4.webp 1780w", "/static/7445f3519b21f17ffd6467340900b2da/3c376/GjiLSO4.webp 1998w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7445f3519b21f17ffd6467340900b2da/e92b6/GjiLSO4.png 223w", "/static/7445f3519b21f17ffd6467340900b2da/e66bf/GjiLSO4.png 445w", "/static/7445f3519b21f17ffd6467340900b2da/4ef49/GjiLSO4.png 890w", "/static/7445f3519b21f17ffd6467340900b2da/4e814/GjiLSO4.png 1335w", "/static/7445f3519b21f17ffd6467340900b2da/701e9/GjiLSO4.png 1780w", "/static/7445f3519b21f17ffd6467340900b2da/1a867/GjiLSO4.png 1998w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7445f3519b21f17ffd6467340900b2da/4ef49/GjiLSO4.png",
              "alt": "GjiLSO4",
              "title": "GjiLSO4",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`$9,217 in sales from October 1st to December 31st. That's not gonna pay rent in San Francisco 😅`}</p>
    <h2 {...{
      "id": "freedom-is-tough"
    }}>{`Freedom is tough`}</h2>
    <p>{`Life was tough, money short, and for the first time in `}<em parentName="p">{`years`}</em>{` I started counting pennies again. Dropped the lattes, stopped taking Uber, bought the cheapest possible boxing gear ...`}</p>
    <p>{`There's this thing about money. Abundance vs. Scarcity mindsets.`}</p>
    <p>{`You want to adopt an abundance mindset. Replace `}<em parentName="p">{`"I don't have enough"`}</em>{` with `}<em parentName="p">{`"How do I get enough?"`}</em>{`. Instead of penny pinching, try making more. Stuff like that.`}</p>
    <p>{`When there's too much month left at the end of the money, it's easy to fall back into scarcity. Especially if you grew up with a scarcity mindset your whole life like I did.`}</p>
    <p>{`So I kept hustling. `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/q1-2019-in-swizec-llc-land-open/swizec/9007"
      }}>{`Q1 of 2019 was amazing`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1113837427674640384"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "161.43497757847533%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'646\\'%20viewBox=\\'0%200%20400%20646\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2023c-4%204-4%204-4%2011l1%207%201%202c0%201%206%205%2010%205%204%201%209%200%2012-3%201-2%201-2-1-2-4%200-5-3-2-5%201-1%203-2%204-1l1-1%202-1c3%200%200-9-5-13-7-5-14-4-19%201m96%2038c-4%203-2%2012%203%2012l3%201h1c-1-1%200-2%201-3%205-5-3-14-8-10m46%20537c1%203%201%204-1%205-4%202-1%206%205%206%204-1%207-5%206-9%200-2%200-2-1%200-1%201-1%201-1-1s-1-3-3-4c-4-2-5-1-5%203m34-2c-3%203-3%207%200%2010%204%206%2013%203%2013-4s-8-10-13-6m21-1c-3%200-5%205-4%209%201%202%201%202%202%201h1c-2%204%205%205%209%202%205-6%200-14-8-12m18%201v6c1%201%201%202-1%202-4%202-1%205%204%205%207%200%2010-9%204-13-3-2-4-3-7%200m15%202c-2%201-1%207%201%209%204%204%2012%202%2012-3%200-2-1-2-5-2s-5%200-5-2c-1-2-2-4-3-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/599d8ae98df134178d58dc51602fc279/ca0a1/techletter.app-screenshot-1563813139908.webp 223w", "/static/599d8ae98df134178d58dc51602fc279/75680/techletter.app-screenshot-1563813139908.webp 445w", "/static/599d8ae98df134178d58dc51602fc279/0ba47/techletter.app-screenshot-1563813139908.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/599d8ae98df134178d58dc51602fc279/e92b6/techletter.app-screenshot-1563813139908.png 223w", "/static/599d8ae98df134178d58dc51602fc279/e66bf/techletter.app-screenshot-1563813139908.png 445w", "/static/599d8ae98df134178d58dc51602fc279/6af66/techletter.app-screenshot-1563813139908.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/599d8ae98df134178d58dc51602fc279/6af66/techletter.app-screenshot-1563813139908.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Product sales were looking up at $14k, I ran two sold out workshops at Reactathon, a late invoice came in, and a wonderful freelance project wrapped up.`}</p>
    <p>{`Swizec was out of the woods. Fuck yeah!`}</p>
    <p>{`Q2 looked almost just as great. Product sales slowed a little due to summer, email engagement slowed in June and July, but it's all good. You're here and I love you ❤️`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1146543745279545344"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "88.34080717488789%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'353\\'%20viewBox=\\'0%200%20400%20353\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2011%206%203%200%205%200%208-2%205-3%205-4%201-4-3%200-4-3-1-5%201-1%203-2%204-1l1-1%202-1%201-2c0-10-14-18-23-12m92%20103c-4%204-2%208%203%2011l5%201c-1-1%200-2%201-3%203-5%200-11-5-11l-4%202m42%20180c-6%207%204%2017%2011%2010%203-3%203-7%200-11-4-3-8-3-11%201m76-2c-7%202-5%2014%202%2014%205%200%207-9%203-13-2-2-3-2-5-1m34%200c-2%202-3%206-2%209%200%203%202%203%202%200%201-2%201-2%203-1%201%201%202%202%201%203v2l2-2c1-3%204-4%204-2l1%201c2-2%201-6-1-9-3-2-7-3-10-1m36%201c-5%204-2%2013%205%2013%206%200%209-6%207-11-3-4-8-5-12-2m-127%200c-3%201-3%209%200%2011l2%201h3c4%201%207-2%207-7-1-5-3-5-3%200l-1%205-3-6h1c1%201%201%200%201-1v-3c1-1%200-1-2-1l-5%201m23%200l2%203-1%201h-1l1%201c1%201%200%201-2%201l-3-1%202-1h1l-2-1v-3l-3%201v4c0%207%204%209%209%206%206-3%204-12-3-12-2%200-2%200%200%201m16%201c-2%203-4%203-2%201v-2c-2%200-3%204-3%208%202%208%2014%206%2014-3%200-6-5-8-9-4m73%202l-3%201c-1%200-2%201-2%203%200%205%208%208%2012%204%203-4%203-7%200-7l-3-1-2-2-2%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c01dd59aefe262bc2b8de1fd51c50adf/ca0a1/techletter.app-screenshot-1563813139370.webp 223w", "/static/c01dd59aefe262bc2b8de1fd51c50adf/75680/techletter.app-screenshot-1563813139370.webp 445w", "/static/c01dd59aefe262bc2b8de1fd51c50adf/0ba47/techletter.app-screenshot-1563813139370.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c01dd59aefe262bc2b8de1fd51c50adf/e92b6/techletter.app-screenshot-1563813139370.png 223w", "/static/c01dd59aefe262bc2b8de1fd51c50adf/e66bf/techletter.app-screenshot-1563813139370.png 445w", "/static/c01dd59aefe262bc2b8de1fd51c50adf/6af66/techletter.app-screenshot-1563813139370.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c01dd59aefe262bc2b8de1fd51c50adf/6af66/techletter.app-screenshot-1563813139370.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And thanks to adopting the `}<a parentName="p" {...{
        "href": "https://profitfirstbook.com/"
      }}>{`Profit First`}</a>{` method of paying yourself first, then the IRS, then you fit the business into what's left, I have more runway in the bank than ever before. Could go 6 months with no income, in San Francisco, and keep my new slimmed-down lifestyle.`}</p>
    <p>{`🤘`}</p>
    <h2 {...{
      "id": "a-gnawing-feeling"
    }}>{`A gnawing feeling`}</h2>
    <p>{`In the beginning it was all hustle. No time to think. Will I make rent this month? Will I pay my freelancers? What do I gotta do to make that happen?`}</p>
    <p>{`Work. Work. Work.`}</p>
    <p>{`As the runway lengthened, as money piled up, a gnawing feeling started to grow 👉 is this worth it?`}</p>
    <p>{`I love teaching. I love solving complex problems and breaking them down for everyone to understand. I love helping coders become engineers. That's a $20k+ difference in salary. I love helping people get that shit and earn what they're worth.`}</p>
    <p>{`But is that the biggest contribution I can make in the world? `}<strong parentName="p">{`If I win this game, was it worth winning?`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`If you don't find a way to make money while you sleep, you will work until you die. ~ Warren Buffett`}</p>
    </blockquote>
    <p>{`Infoproducts make money while you sleep. You set up your funnels, your mailing list, your sales page, you run a couple launches per year, and yeah you're making money while you sleep.`}</p>
    <p>{`The infoproduct playbook is a simple one:`}</p>
    <ol>
      <li parentName="ol">{`Offer shitloads of value for free`}</li>
      <li parentName="ol">{`Get email subscribers`}</li>
      <li parentName="ol">{`Launch 1 product per quarter`}</li>
      <li parentName="ol">{`Convert about 1% of your list each time`}</li>
      <li parentName="ol">{`Money falls out`}</li>
    </ol>
    <p>{`You will never get more than about 1% conversions. You will never convert more than 5% on your sales page. You will never have more than 10% opt-ins on your email list. You will never churn less than 0.1% of email opens.`}</p>
    <p>{`That's the physics.`}</p>
    <p>{`Can you make $10,000/year with infoproducts? Easy.`}</p>
    <p>{`Can you make $100,000/year with infoproducts? Yeah, just keep pulling that lever.`}</p>
    <p>{`Can you make $1,000,000/year? Tough. A few dozen people pulled it off.`}</p>
    <p>{`Can you make $10,000,000/year? Oof. Maybe like 5 people managed to do that?`}</p>
    <p>{`Can you make $100,000,000/year? Yeah maybe if you're Tony Robbins.`}</p>
    <p>{`It's kinda soul crushing when you think about it. You're putting in all that risk and hard work and the most you'll ever have is a small business that lives and dies on its next launch.`}</p>
    <p>{`Like showbiz: You're only as good as your last hit.`}</p>
    <hr></hr>
    <p>{`Plus technical infoproducts are really more of a sidehustle.`}</p>
    <p>{`You need a constant stream of interesting challenges. Stuff to write about. Things to teach.`}</p>
    <p>{`If all you do is teach, you drift from industry best practice and your teaching becomes shit. You need to keep your hands in the real world.`}</p>
    <p>{`And anyway do you really want to keep saying and re-saying the same stuff for the next 10 years of your life? Techniques you figured out years ago and know like the back of your hand?`}</p>
    <p>{`I don't know about you, but I'm a very bad lever puller. It's fun the first time. The first 5 times maybe. Then I want to find a new lever.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The biggest reason why smart people fail is that they get bored of doing what works.`}</p>
    </blockquote>
    <p>{`That's me.`}</p>
    <h2 {...{
      "id": "the-day-job-gets-better"
    }}>{`The day job gets better`}</h2>
    <p>{`At the same time as I realized what it would take to scale my business to the $120,000/year minimum that I need in San Francisco, the day job got `}<em parentName="p">{`so much better`}</em>{`.`}</p>
    <p>{`My boss changed.`}</p>
    <p>{`The new kid is awesome. A manager who really tries to manage. Who's invested in figuring out how this management thing works. Not just an engineer who scoffs at the idea that management is a real job with real challenges.`}</p>
    <p>{`First thing he did was give me a raise. That was nice, helped me breathe.`}</p>
    <p>{`More importantly he stopped treating me like a 2nd class citizen just because I was contracting. That was beyond wonderful. I became involved in real decisions again. I was asked questions. My opinion became valued.`}</p>
    <p>{`Sure I loved the few months where I could do nothing but focus and code. It was a wonderful break from the stress and ambiguity of before.`}</p>
    <p>{`I had started to chafe at the constraints. I like being an IC (individual contributor) and I never want to become a manager. That's a different job.`}</p>
    <p>{`But when I say IC, I don't mean a task executor. I want to be something more akin to an internal consultant.`}</p>
    <p>{`The guy who solves tough business critical technical challenges. You come to me with a problem, you set me loose, and I solve it for you.`}</p>
    <p>{`That's my sweet spot I think. A leader, but not a manager.`}</p>
    <p>{`And under my new boss, the day job started morphing into that. I became more and more engaged. I started to enjoy coming into the office again.`}</p>
    <p>{`When an opportunity showed up to make a big bet, but I gotta return full-time, I said `}<em parentName="p">{`"Fuck yes let's do it!"`}</em></p>
    <h2 {...{
      "id": "so-what-happens-next"
    }}>{`So what happens next?`}</h2>
    <p>{`Today is my first day of being full-time at `}<a parentName="p" {...{
        "href": "https://www.yup.com/"
      }}>{`Yup`}</a>{`. We have big plans in store.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1149755536335724544"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "161.43497757847533%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'646\\'%20viewBox=\\'0%200%20400%20646\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2020c-3%202-7%206-8%2010-1%203%201%2011%203%2011v1c0%202%205%206%209%207%204%200%209-1%2012-3l3-2-4-1c-5-1-4-6%202-6l2-2h1c2%201%202-3%201-6-3-8-13-12-21-9m33%20232l-2%208c1%201%2016-6%2016-7s-3-6-5-7c-4-3-5-2-9%206m50%20344c-3%203-3%206-1%209%202%205%2012%205%2010%200l1-3c5-1%201-6-4-5-4%200-5-1-2-2l3-1h-3l-4%202m20-1v1h-1v1l-1%201c-2-2-3%204-1%207%204%206%2013%203%2013-4%200-2%200-3-1-2s-4-2-4-4h-5m17%201c-7%205-1%2015%207%2012%205-2%206-8%202-11-3-4-6-4-9-1m35%200c-6%207%204%2017%2010%2011%204-3%204-7%201-10-3-4-8-4-11-1m37-1c-5%204-2%2014%205%2014%206%200%2010-11%204-12l-3-1c0-2-3-2-6-1m19%201c-4%203-4%208-1%2011h3l3-1%201-3%202-3c2-2%202-3%201-4-2-2-3-1-2%201%200%202%200%202-1%201-2-1-2-2-1-3%202-2-2-1-5%201m-71%202c-6%205-5%2010%203%209%207%200%209-6%204-10-2-3-3-2-7%201m34-1c-3%202-3%203-3%206%202%206%208%208%2013%204%202-3%203-5%201-7l-3-2c-1-3-4-3-8-1m57-1v11c-2%202%203%202%206%200%204-2%205-10%202-9-1%201-2%200-3-1-1-2-3-3-5-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ee534462333d4e0ca69959ee89e2022/ca0a1/techletter.app-screenshot-1563813140111.webp 223w", "/static/7ee534462333d4e0ca69959ee89e2022/75680/techletter.app-screenshot-1563813140111.webp 445w", "/static/7ee534462333d4e0ca69959ee89e2022/0ba47/techletter.app-screenshot-1563813140111.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ee534462333d4e0ca69959ee89e2022/e92b6/techletter.app-screenshot-1563813140111.png 223w", "/static/7ee534462333d4e0ca69959ee89e2022/e66bf/techletter.app-screenshot-1563813140111.png 445w", "/static/7ee534462333d4e0ca69959ee89e2022/6af66/techletter.app-screenshot-1563813140111.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7ee534462333d4e0ca69959ee89e2022/6af66/techletter.app-screenshot-1563813140111.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I'm keeping the side hustle. I love you guys too much to peace out ❤️`}</p>
    <p>{`But for now my focus is shifting. More long term stuff, less week-to-week hustle.`}</p>
    <p>{`You're going to continue getting these emails. They might become less frequent. I hope to keep it up twice a week. A little less purely educational, a little more sharing lessons learned in the real world.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/channel/UCoyHgaeLLI7Knp7LDHOwZMw"
      }}>{`Livecoding`}</a>{` continues with a focus on building cool stuff and hanging out. It's a great commitment device for when I get an idea for a cool project.`}</p>
    <p>{`Right now I have a longer list of project ideas than I have time 😅`}</p>
    <p>{`I'm launching a new course this Fall. Recording is almost done and I'm stoked as hell. I think you're gonna love it.`}</p>
    <p>{`And I'm going to keep doing workshops when the opportunity arises. They're fun.`}</p>
    <p>{`Beyond that I have some long-term long-term ideas (think years, not months) that have been gestating for a while and I've been too busy hustling to get started.`}</p>
    <p>{`For now 👇`}</p>
    <p>{`When someone offers you a ride on a rocket ship, you hop on.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      